import { useApiPost } from '../../common/api/Api.hooks';
import { User } from '../../user/User.interface';
// import { useEffect, useContext, useRef } from 'react';
// import { JwtToken } from '../../user/JwtToken.interface';
// import { UserContext } from '../../user/User.context';

export function useElectronicSignature() {
  let { data, isLoading, error, post } = useApiPost<User>('users/sign');
  // const { user } = useContext(UserContext);
  // const userRef = useRef(user);
  // useEffect(() => {
  //   const jwt = data as JwtToken;
  //   if (data && !isLoading && jwt.user.id !== userRef.current.id) {
  //     data = undefined;
  //     error = new FetchError('Incorrect user');
  //   }
  // }, []);
  return { signed: Boolean(data), isLoading, error, post };
}
